import {DatePicker, message, Select, Table} from 'antd';
import React, { Component } from 'react';
import Chart from "react-apexcharts";
import moment from "moment-timezone";
import {map, orderBy} from 'lodash';
import DataTable from "./Datatable";
import Loader from "../../Common/Component/Loader";
import {errorHandle} from "../../Common/errorHandle";
import {formatToCurrency} from "../../../Tools/formatToCurrency";

const {Option} = Select;

// pie colors
const pie_colors = ['#407977', '#b3f3d9', '#F99D20', '#CDE059', '#3ba93f', '#abd3d2'];
const pie_colors_class = ['green-1', 'light-green', 'orange-1', 'lime', 'dark-green', 'ripple-green'];

class FranchiseDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      green_series: [{
        name: "Desktops",
        data: [10, 41, 10, 60, 10, 70]
      }],

      loader: false,
      is_edit_franchise: false,
      data: {},
      franchise_detail: {},
      collectionDetail: {},
      productMonth: moment(),
      addonCollectionDetail: {},
      addon_series: [],
      addon_options: {
        chart: {
          type: 'donut'
        },
        dataLabels: {
          enabled: false,
        },
        legend: {show: false},
        tooltip: {
          enabled: true,
          custom: ({series, seriesIndex}) => {
            //{series, seriesIndex, dataPointIndex, w}
            return '<div style="background-color: #FFFFFF; padding: 10px; color: #000000">' +
              '<span>' + formatToCurrency(series[seriesIndex]) + '</span>' +
              '</div>'
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              labels: {show: false},
            },
          }
        }
      },

      fullCardMonth: moment(),
      customerMatrix: {},
      revenueFilterIdx: 0,
      customerMatrixV1: {},
      customerMonth: moment(),

      line_chart_options: {
        chart: {
          toolbar: {
            show: false
          },
          foreColor: "#ccc",
        },
        colors: ["#F99D20"],
        stroke: {
          colors: ['#F99D20'],
          curve: 'smooth',
          width: 1,
        },
        grid: {
          show: false,
          padding: {
            left: 0,
            right: 0,
          }
        },
        xaxis: {
          labels: {
            show: false,
          },
        },
        yaxis: {
          show: false,
          padding: {
            left: 0,
            right: 0
          }
        },
        markers: {
          show: false
          // size: [4, 7],
          // colors: ['#C1D82F'],
        }
      },
      customerFilterIdx: 0,
      serviceFilterIdx: 0,
      fullCardIdx: 0,
      call_logged_month: moment(),
      assigned_tickets_month: moment(),
      revenue_month: moment(),
      top_chart_options: {
        stroke: {
          colors: ['#C1D82F'],
          curve: 'smooth',
          width: 1,
        }
      },

      ticket_filter: '',
      messageData: {},
      messageAssignedToMe: {},
      customerSatisfaction: {},
      callLogged: {},
      assignedTickets: {},
      isCustomerSatisfaction: true,
      isDashboardStat: true,
      isCallLogged: true,
      isAssignedTickets: true,
      serviceTypeCollection: {},
      service_type_options: {
        chart: {
          type: 'donut'
        },
        dataLabels: {
          enabled: false,
        },
        legend: {show: false},
        tooltip: {
          enabled: true,
          custom: ({series, seriesIndex}) => {
            //{series, seriesIndex, dataPointIndex, w}
            return '<div style="background-color: #FFFFFF; padding: 10px; color: #000000">' +
              '<span>' + parseFloat(series[seriesIndex]).toFixed(2) + '</span>' +
              '</div>'
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              labels: {show: false},
            },
          }
        }
      },
      auditTrail: {},
      audit_filter: ''
    }
    this.emptyProductChart = null
  }

  componentDidMount() {
    const authUser = JSON.parse(localStorage.getItem('authUser'))
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);
    const data = {uuid: franchise_uuid?.[0]}; //'8b2e407c-240f-4f4b-a758-d117f84889bc'
    this.setState({ data: data, loader: true }, () => {
      const {data, productMonth, fullCardMonth, customerMonth} = this.state;
      const {is_corporate} = this.getLoggedInUserRole()
      this.props.getCollectionDetail(`?field_office__uuid=${data?.uuid}`) // get collection detail
      this.props.getAddOnCollectionDetail(`?field_office__uuid=${data?.uuid}&timestamp__gte=${moment(productMonth).startOf('month').format('YYYY-MM-DDTHH:mm:ss')}&timestamp__lte=${moment(productMonth).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}`) // get add on collection detail
      // this.props.getAddOnCollectionDetail(`?field_office__uuid=8b2e407c-240f-4f4b-a758-d117f84889bc&timestamp__gte=2021-02-01T00%3A00%3A00&timestamp__lte=2021-02-28T23%3A59%3A59`)
      let date = moment(fullCardMonth).format('DD') >= 21 ? moment(fullCardMonth).endOf('month').format('YYYY-MM-DD') : moment(fullCardMonth).format('YYYY-MM-DD')
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)  // get dashboard stat
      this.props.getCustomerMatrix(`?field_office__uuid=${data?.uuid}&timestamp__lte=${moment().format('YYYY-MM-DD')}T23:59:59`) // get customer matrix
      this.props.getCustomerMatrix_v1(`?field_office__uuid=${data?.uuid}&timestamp__lte=${moment(customerMonth).format('YYYY-MM-DD')}T23:59:59`) // get customer matrix v1 for recurring customer signup
      this.props.getAllMessages({user__serviceorder__field_office__uuid: is_corporate ? '' : data?.uuid, limit: 5, offset: 0}) // get Tickets
      this.props.getAssignedToMeMessage({assigned_user__uuid: authUser?.user?.uuid}) // get Tickets assigned to me
      this.props.getServiceTypeCollection({field_office__uuid: data?.uuid}) // get service type collection
      this.props.getAuditTrail({user__serviceorder__field_office__uuid: data?.uuid, limit: 7, offset: 0}) // get audit trail data
      this.props.getFranchiseGroupList({field_office__uuid: data?.uuid})  // get group list for logged in user franchise
    });
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()

    ///////////error handle /////////////////////
    if (Object.keys(nextProps?.FranchiseOverview?.errors).length > 0 && nextProps?.FranchiseOverview?.errors !== this.props?.FranchiseOverview?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.FranchiseOverview?.errors)
    }

    if (Object.keys(nextProps?.AllMessages?.errors).length > 0 && nextProps?.AllMessages?.errors !== this.props?.AllMessages?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AllMessages?.errors)
    }

    if (Object.keys(nextProps?.Dashboard?.errors).length > 0 && nextProps?.Dashboard?.errors !== this.props?.Dashboard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Dashboard?.errors)
    }
    /////////////////////////////////////////////

    // get collection detail
    if (Object.keys(nextProps?.FranchiseOverview?.collectionDetail).length > 0 && nextProps?.FranchiseOverview?.collectionDetail !== this.props?.FranchiseOverview?.collectionDetail) {
      this.setState({collectionDetail: nextProps?.FranchiseOverview?.collectionDetail, loader: false})
    }

    // get add on collection detail
    if (Object.keys(nextProps?.FranchiseOverview?.addonCollectionDetail).length > 0 && nextProps?.FranchiseOverview?.addonCollectionDetail !== this.props?.FranchiseOverview?.addonCollectionDetail) {
      let addon_series = [], labels = [], addonCollectionDetail = nextProps?.FranchiseOverview?.addonCollectionDetail;
      map(addonCollectionDetail?.results, x => {
        addon_series.push(x?.revenue);
        labels.push('test')
      })
      this.setState({addonCollectionDetail, addon_series, loader: false})
    }

    // get dashboard stat
    if (Object.keys(nextProps?.FranchiseOverview?.dashboardStat).length > 0 && nextProps?.FranchiseOverview?.dashboardStat !== this.props?.FranchiseOverview?.dashboardStat) {
      const {isCustomerSatisfaction, isDashboardStat, isCallLogged, isAssignedTickets} = this.state;
      if (isCustomerSatisfaction) {
        this.setState({customerSatisfaction: nextProps?.FranchiseOverview?.dashboardStat?.data, isCustomerSatisfaction: false})
      }
      if (isDashboardStat) {
        this.setState({dashboardStat: nextProps?.FranchiseOverview?.dashboardStat?.data, isDashboardStat: false})
      }
      if (isCallLogged) {
        this.setState({callLogged: nextProps?.FranchiseOverview?.dashboardStat?.data, isCallLogged: false})
      }
      if (isAssignedTickets) {
        this.setState({assignedTickets: nextProps?.FranchiseOverview?.dashboardStat?.data, isAssignedTickets: false})
      }
      this.setState({loader: false})
    }

    // get customer matrix
    if (Object.keys(nextProps?.FranchiseOverview?.customerMatrix).length > 0 && nextProps?.FranchiseOverview?.customerMatrix !== this.props?.FranchiseOverview?.customerMatrix) {
      this.setState({customerMatrix: nextProps?.FranchiseOverview?.customerMatrix, loader: false})
    }

    // get customer matrix v1
    if (Object.keys(nextProps?.FranchiseOverview?.customerMatrixV1).length > 0 && nextProps?.FranchiseOverview?.customerMatrixV1 !== this.props?.FranchiseOverview?.customerMatrixV1) {
      this.setState({customerMatrixV1: nextProps?.FranchiseOverview?.customerMatrixV1, loader: false})
    }

    //get Message
    if (Object.keys(nextProps?.AllMessages?.data).length > 0 && nextProps?.AllMessages?.data !== this.props?.AllMessages?.data) {
      this.setState({messageData: nextProps?.AllMessages?.data, loader: false})
    }

    //get assigned to me
    if (Object.keys(nextProps?.Dashboard?.messageAssignedToMe).length > 0 && nextProps?.Dashboard?.messageAssignedToMe !== this.props?.Dashboard?.messageAssignedToMe) {
      this.setState({messageAssignedToMe: nextProps?.Dashboard?.messageAssignedToMe, loader: false})
    }

    //get service type collection
    if (Object.keys(nextProps?.Dashboard?.serviceTypeCollection).length > 0 && nextProps?.Dashboard?.serviceTypeCollection !== this.props?.Dashboard?.serviceTypeCollection) {
      this.setState({serviceTypeCollection: nextProps?.Dashboard?.serviceTypeCollection, loader: false})
    }

    //get audit trail data
    if (Object.keys(nextProps?.Dashboard?.auditTrail).length > 0 && nextProps?.Dashboard?.auditTrail !== this.props?.Dashboard?.auditTrail) {
      this.setState({auditTrail: nextProps?.Dashboard?.auditTrail, loader: false})
    }

    //get group list
    if (Object.keys(nextProps?.Dashboard?.groupList).length > 0 && nextProps?.Dashboard?.groupList !== this.props?.Dashboard?.groupList) {
      this.setState({groupList: nextProps?.Dashboard?.groupList, loader: false})
    }

    this.setState({loader: false})
  }

  // calculate growth percentage
  calculateGrowthPercentage = (last_val, curr_val) => {
    let divider = last_val
    if (divider === 0) divider = 1
    return parseFloat(((curr_val - last_val) * 100) / divider).toFixed(2)
  }

  // on text change
  onTextChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };

  // number k and m format
  numFormatter = (num) => {
    if (num > 999 && num < 1000000) {
      return (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
      return (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  // amount formatter
  numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + '-' + phone?.substr(3, 3) + '-' + phone?.substr(6);
  }

  //Close drawer
  closeEditDrawer = (type) => {
    this.setState({
      is_edit_franchise: type
    })
  }

  openEditDrawer = () => {
    this.props.editFieldOffice(this.state.data.uuid);
    this.setState({ is_edit_franchise: true });
  }

  // on change product month
  onChangeProductMonth = (e) => {
    this.setState({productMonth: e ? e : moment(), loader: true}, () => {
      const {data, productMonth} = this.state;
      this.props.getAddOnCollectionDetail(`?field_office__uuid=${data?.uuid}&timestamp__gte=${moment(productMonth).startOf('month').format('YYYY-MM-DDTHH:mm:ss')}&timestamp__lte=${moment(productMonth).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}`)
    })
  }

  // on change product month
  onChangeFullCardMonth = (e) => {
    this.setState({fullCardIdx: e, loader: true, isDashboardStat: true}, () => {
      const {data, fullCardIdx} = this.state;
      let date = '';
      if (fullCardIdx === 0) {
        date = moment().format('DD') >= 21 ? moment().endOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      } else if (fullCardIdx === 1) {
        date = moment().format('YYYY-MM-DD')
      } else {
        date = moment().format('YYYY-MM-DD')
      }
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
    })
  }

  // on change product month
  onChangeCustomerMonth = (e) => {
    this.setState({customerMonth: e ? e : moment(), loader: true}, () => {
      const {data, customerMonth} = this.state;
      this.props.getCustomerMatrix_v1(`?field_office__uuid=${data?.uuid}&timestamp__lte=${moment(customerMonth).format('YYYY-MM-DD')}T23:59:59`) // get customer matrix
    })
  }

  // on change satisfaction month
  onChangeSatisfactionMonth = (e) => {
    this.setState({satisfyMonth: e ? e : moment(), isCustomerSatisfaction: true}, () => {
      const {data, satisfyMonth} = this.state;
      const date = moment(satisfyMonth).format('YYYY-MM-DD')
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
    })
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    const is_corporate = logged_in_user_role?.includes('admin')
    return {is_corporate}
  }
  // on ticket filter change
  onTicketFilterChange = (e) => {
    this.setState({ticket_filter: e, loader: true}, () => {
      const {data, ticket_filter} = this.state;
      const {is_corporate} = this.getLoggedInUserRole()
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      let obj = {};
      if (ticket_filter === "me") obj = {assigned_user__uuid: authUser?.user?.uuid}
      else obj = {user__serviceorder__field_office__uuid: is_corporate ? '' : data?.uuid, assigned_group__uuid: ticket_filter}
      this.props.getAllMessages({...obj ,limit: 5, offset: 0}) // get Tickets
    })
  }

  // on change satisfaction month
  onChangeCallLoggedCardMonth = (e) => {
    let obj = {}, name = e.target.name;
    if (name === 'call_logged_month') {
      obj = {isCallLogged: true}
    } else if (name === 'assigned_tickets_month') {
      obj = {isAssignedTickets: true}
    }
    this.setState({[name]: e.target.value ? e.target.value : moment(), ...obj}, () => {
      const {data} = this.state;
      let date = moment(this.state[name]).format('YYYY-MM-DD');
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
    })
  }

  // Empty revenue card
  renderEmptyRevenueCard = () => {
    return (
      <div className="card">
        <div className="card-title flex ai-center">
          <h5>Customer Metrics</h5>
        </div>
        <div className="card-body">
          <h2 style={{color: '#F99D20'}}>%</h2>
          <b>No Customer Metrics</b>
          <label>When your customers review their service, you will be able to see that here.</label>
        </div>
      </div>
    )
  }

  // render revenue card
  renderRevenueCard = () => {
    const {dashboardStat, revenueFilterIdx, customerMatrix, line_chart_options} = this.state;
    let total = 0.00, series = [], categories = [], last_6_months = [], next_6_months = [];
    if (revenueFilterIdx === 0 || revenueFilterIdx === 2) {
      for (let i = 5; i >= 0; i--) {
        last_6_months.push(moment().subtract(i, 'months').format('MMM YYYY'))
        categories.push(moment().subtract(i, 'months').format('MMM'))
        series.push(0)
      }
    } else if (revenueFilterIdx === 1) {
      for (let i = -1; i <= 4; i++) {
        next_6_months.push(moment().add(i, 'months').format('MMM YYYY'))
        categories.push(moment().add(i, 'months').format('MMM'))
        series.push(0)
      }
    }

    map(orderBy(customerMatrix?.results, 'timestamp', 'asc'), x => {
      if (revenueFilterIdx === 0 || revenueFilterIdx === 2) {
        let idx = last_6_months.indexOf(moment(x?.timestamp).format('MMM YYYY'))
        if ( idx > -1 ) {
          total += x?.revenue
          series[idx] = x?.revenue
        }

      } else if (revenueFilterIdx === 1) {
        let idx = next_6_months.indexOf(moment(x?.timestamp).format('MMM YYYY'))
        if ( moment(x?.timestamp).format('YYYY') === moment().format('YYYY') && idx > -1) {
          total += x?.revenue
          series[idx] = x?.revenue
        }
      }
    })

    return (
      <div className="card revenue h-98">
        <div className="card-title flex ai-center">
          <h3 className="font-weight-bold pr-30">Revenue</h3>
          <ul className="tabs mwhite">
            <li className={revenueFilterIdx === 0 ? `active` : ''} onClick={() => this.setState({revenueFilterIdx: 0})}><span>Month</span></li>
            <li className={revenueFilterIdx === 1 ? `active` : ''} onClick={() => this.setState({revenueFilterIdx: 1})}><span>Year</span></li>
            <li className={revenueFilterIdx === 2 ? `active` : ''} onClick={() => this.setState({revenueFilterIdx: 2})}><span>All-Time</span></li>
          </ul>
        </div>
        <div className="card-body pl-0 pr-0 h-98">
          <span className="heading">${formatToCurrency(total)}
            <label className="mb-0">{revenueFilterIdx === 0 ? 'Monthly' : revenueFilterIdx === 1 ? 'Yearly' : 'All Time'} Revenue</label>
          </span>

          <div className="chart" style={{height : "80%"}}>
            {series?.length > 0 ?
              <Chart
                options={{...line_chart_options, xaxis: {
                  categories: categories,
                  labels: {
                    show: true,
                  },
                }}}
                series={[{data: series}]}
                type="line"
              /> :
              <Chart
                options={line_chart_options}
                series={[{data: new Array(6).fill(0)}] }
                type="line"
              />
            }
            <div className="form-group px-30" style={{height: "100%"}}>
              <h3>Projections</h3>
              <div className="flex flex-column h-100" style={{alignContent: "space-between"}}>
                <div className="flex flex-1 w-100">
                  <div className="flex-1 revenue_details">
                    <h2 className="success mb-0">${dashboardStat?.revenue_till_current_date ? formatToCurrency(dashboardStat?.revenue_till_current_date) : '0.00'}</h2>
                    <span>Work completed to <br /> <u>{moment().format('MMM Do')}</u></span>
                  </div>
                  <div className="flex-1 revenue_details">
                    <h2 className="success mb-0">${dashboardStat?.projections_from_current_date_to_end_of_year ? formatToCurrency(dashboardStat?.projections_from_current_date_to_end_of_year) : '0.00'}</h2>
                    <span>Work scheduled to end of <br /> year if services continue</span>
                  </div>
                </div>
                <div className="wrapbox flex-1 w-100">
                  <div className="greenbox" style={{border: "1px #407977 solid"}}>
                    <h2 className="success">${dashboardStat?.current_year_projections ? formatToCurrency(dashboardStat?.current_year_projections) : '0.00'}</h2>
                    <b>{moment().format('YYYY')} Projections</b>
                  </div>
                  <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/account', { query: { current: 4 } })}}><u className="success mt-10"><b>See Unbilled Work Report</b></u></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // render top cards
  renderTopCards = () => {
    const {line_chart_options, top_chart_options, dashboardStat, revenue_month, green_series} = this.state;
    let card_list = [{
      amount: dashboardStat?.current_month_revenue?.toString() || '0', title: `${dashboardStat?.current_month} Revenue`,
      progress: this.calculateGrowthPercentage(dashboardStat?.current_month_revenue_last_year, dashboardStat?.current_month_revenue).toString(),
      month: `Compared to ${dashboardStat?.current_month}`, key: 'revenue_month', selectedMonth: revenue_month,
    }, {
      amount: dashboardStat?.ytd_revenue?.toString() || '0', title: 'YTD',
      progress: this.calculateGrowthPercentage(dashboardStat?.last_ytd_revenue, dashboardStat?.ytd_revenue).toString(),
      month: 'Compared to last YTD', /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
    }]

    return (
      <div className="top_grid flex align-items-stretch">
        {map(card_list, (item, index) => {
          return (
            <div className="card" key={`top_cards${index}`}>
              <div className="card-body position-relative pt-40">
                {item?.key ? <div className={"only-icon-datepick"} style={{position:"absolute",right:"6px",top:"6px", display: "flex", justifyContent: "flex-end"}}>
                  <DatePicker
                    disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                    onChange={(e) => this.setState({[item?.key]: e})}
                    className="swhite summry_date_picker flex-end"
                    format="MMM YYYY"
                    picker="month"
                    value={item?.selectedMonth ? item?.selectedMonth : moment()}  /></div> : ''}
                <div className="small_chart flex">
                  <div className="details">
                    <h2>${this.numFormatter(item?.amount)}  <small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up'}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}%
                      </span>
                      <p className="mb-0">{item?.month}</p>
                    </div>
                  </div>
                  <div className="chart">
                    <Chart
                      options={{...line_chart_options, ...top_chart_options}}
                      series={green_series}
                      type="line"
                      width="180"
                      height="80"
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  // render call logged cards
  renderCallLoggedCard = () => {
    const {line_chart_options, top_chart_options, call_logged_month, assigned_tickets_month, callLogged, assignedTickets, green_series} = this.state;
    let card_list = [{
      amount: callLogged?.calls_logged?.toString(), title: `Call Logged`, key: 'call_logged_month', selectedMonth: call_logged_month,
      progress: this.calculateGrowthPercentage(callLogged?.previous_month_calls_logged, callLogged?.calls_logged).toString(),
      month: `Compared to ${callLogged?.previous_month}`
    }, {
      amount: assignedTickets?.assigned_tickets?.toString(), title: 'Assigned', key: 'assigned_tickets_month', selectedMonth: assigned_tickets_month,
      progress: this.calculateGrowthPercentage(assignedTickets?.previous_month_assigned_tickets, assignedTickets?.assigned_tickets).toString(),
      month: `Compared to ${assignedTickets?.previous_month}`
    }]

    return (
      <div className="top_grid flex align-items-stretch">
        {map(card_list, (item, index) => {
          return (
            <div className="card mr-30" key={`top_cards${index}`}>
              <div className="card-body position-relative pt-40">
                <div className={"only-icon-datepick"} style={{position:"absolute",right:"6px",top:"6px",display: "flex", justifyContent: "flex-end"}}>
                  <DatePicker
                    disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                    onChange={(e) => this.onChangeCallLoggedCardMonth({target: {name: item?.key, value: e}})}
                    className="swhite summry_date_picker flex-end"
                    format="MMM YYYY"
                    picker="month"
                    allowClear={false}
                    value={item?.selectedMonth ? item?.selectedMonth : moment()}  />
                </div>
                <div className="small_chart flex">
                  <div className="details">
                    <h2>{formatToCurrency(item?.amount)}  <small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress !== '0.00' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}%
                      </span>
                      <p className="mb-0">{item?.month}</p>
                    </div>
                  </div>
                  <div className="chart">
                    <Chart
                      options={{...line_chart_options, ...top_chart_options}}
                      series={green_series}
                      type="line"
                      width="180"
                      height="80"
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  // render full card
  renderFullCard = () => {
    const {dashboardStat, fullCardIdx} = this.state;
    let card_list = []
    if (fullCardIdx === 0) {
      card_list = [{
        count: dashboardStat?.new_customers?.toString(), title: 'New Customers',
        progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers).toString(),
        month: dashboardStat?.current_month
      }, {
        count: dashboardStat?.cancelled_customers?.toString(), title: 'Cancellation',
        progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }, {
        count: (dashboardStat?.service_sign_ups || 0)?.toString(), title: 'Service Sign Ups',
        progress: this.calculateGrowthPercentage(dashboardStat?.service_sign_ups_last_year || 0, dashboardStat?.service_sign_ups || 0).toString(),
        month: dashboardStat?.current_month
      }, {
        count: dashboardStat?.net_gain?.toString(), title: 'Net Gain',
        progress: this.calculateGrowthPercentage(dashboardStat?.net_gain_last_year, dashboardStat?.net_gain).toString(),
        month: dashboardStat?.current_month
      }]
    } else if (fullCardIdx === 1) {
      card_list = [{
        count: dashboardStat?.new_customers_this_year?.toString(), title: 'New Customers',
        progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers_this_year).toString(),
        month: dashboardStat?.current_month
      }, {
        count: dashboardStat?.cancelled_customers_this_year?.toString(), title: 'Cancellation',
        progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers_this_year).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }, {
        count: (dashboardStat?.service_sign_ups || 0)?.toString(), title: 'Service Sign Ups',
        progress: this.calculateGrowthPercentage(dashboardStat?.service_sign_ups_last_year || 0, dashboardStat?.service_sign_ups || 0).toString(),
        month: dashboardStat?.current_month
      }, {
        count: dashboardStat?.net_gain_this_year?.toString(), title: 'Net Gain',
        progress: this.calculateGrowthPercentage(dashboardStat?.net_gain_last_year, dashboardStat?.net_gain_this_year).toString(),
        month: dashboardStat?.current_month
      }]
    } else if (fullCardIdx === 2) {
      card_list = [{
        count: dashboardStat?.new_customers_all_time?.toString(), title: 'New Customers',
        progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers_all_time).toString(),
        month: dashboardStat?.current_month
      }, {
        count: dashboardStat?.cancelled_customers_all_time?.toString(), title: 'Cancellation',
        progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers_all_time).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }, {
        count: (dashboardStat?.service_sign_ups || 0)?.toString(), title: 'Service Sign Ups',
        progress: this.calculateGrowthPercentage(dashboardStat?.service_sign_ups_last_year || 0, dashboardStat?.service_sign_ups || 0).toString(),
        month: dashboardStat?.current_month
      }, {
        count: dashboardStat?.net_gain_all_time?.toString(), title: 'Net Gain',
        progress: this.calculateGrowthPercentage(dashboardStat?.net_gain_last_year, dashboardStat?.net_gain_all_time).toString(),
        month: dashboardStat?.current_month
      }]
    }

    return (
      <div className="middle_grid card flex flex-start flex-wrap mr-30">
        <div className="card-body flex flex-wrap" style={{display: "flex", alignItems: "center"}}>
          <div className="fitem flex-auto mr-2">
            <ul className="tabs mwhite d-block">
              <li className={fullCardIdx === 0 ? `active` : ''} onClick={() => this.onChangeFullCardMonth(0)}><span>Month</span></li>
              <li className={fullCardIdx === 1 ? `active` : ''} onClick={() => this.onChangeFullCardMonth(1)}><span>Year</span></li>
              <li className={fullCardIdx === 2 ? `active` : ''} onClick={() => this.onChangeFullCardMonth(2)}><span>All-Time</span></li>

            </ul>
          </div>
          {
            map(card_list, (item, index) => {
              return (
                <div className="small_chart flex-auto mr-2" key={`full_card${index}`}>
                  <div className="details">
                    <h2>{item?.count}<small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress !== '0.00' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}% {item?.link}
                      </span>
                      <p className="mb-0">Compared to last {item?.month}</p>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  // render full card
  renderCustomerSatisfaction = () => {
    const {satisfyMonth, customerSatisfaction} = this.state;
    let card_list = [{
      count: customerSatisfaction?.customer_satisfaction_last_year?.toString(), title: '',
      progress: parseFloat(this.calculateGrowthPercentage(customerSatisfaction?.customer_satisfaction_last_year, customerSatisfaction?.customer_satisfaction)).toFixed(2).toString(),
      month: moment(satisfyMonth).subtract(1, 'year').format('MMM YYYY')
    }, {
      count: customerSatisfaction?.previous_month_customer_satisfaction?.toString(), title: '',
      progress: parseFloat(this.calculateGrowthPercentage(customerSatisfaction?.previous_month_customer_satisfaction, customerSatisfaction?.customer_satisfaction)).toFixed(2).toString(),
      month: moment(satisfyMonth).subtract(1, 'month').format('MMM YYYY')
    }, {
      count: customerSatisfaction?.four_month_back_customer_satisfaction?.toString(), title: '',
      progress: parseFloat(this.calculateGrowthPercentage(customerSatisfaction?.four_month_back_customer_satisfaction, customerSatisfaction?.customer_satisfaction)).toFixed(2).toString(),
      month: moment(satisfyMonth).subtract(4, 'month').format('MMM YYYY')
    }]
    return (
      <div className="middle_grid card flex flex-start flex-wrap mr-30">
        <div className="card-body flex flex-wrap">
          <div className="small_chart fitem flex-auto mr-2">
            <h6>Customer Satisfaction</h6>
            <DatePicker
              disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
              onChange={this.onChangeSatisfactionMonth}
              className="swhite summry_date_picker"
              format="MMM YYYY"
              picker="month"
              value={satisfyMonth ? satisfyMonth : moment()}  />
          </div>
          {
            map(card_list, (item, index) => {
              return (
                <div className="small_chart flex-auto mr-2" key={`full_card${index}`}>
                  <div className="details">
                    <h2>{parseFloat(item?.count).toFixed(2)}<small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress !== '0.00' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}% {item?.link}
                      </span>
                      <p className="mb-0">Compared to {item?.month}</p>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  // render customer card
  renderCustomerCard = () => {
    const { line_chart_options, addonCollectionDetail, customerFilterIdx, customerMatrixV1, customerMatrix, customerMonth } = this.state;
    let total = 0, recurring_customers = 0, one_time_customers = 0, cancelled_customers = 0, net_gain = 0, series = [], categories = [], last_6_months = [];
    map(addonCollectionDetail?.results, x => total += x?.revenue)
    for (let i = 5; i >= 0; i--) {
      last_6_months.push(moment().subtract(i, 'months').format('MMM YYYY'))
      categories.push(moment().subtract(i, 'months').format('MMM'))
      series.push(0)
    }
    map(orderBy(customerMatrixV1?.results, 'timestamp', 'asc'), x => {
      const idx = last_6_months.indexOf(moment(x?.timestamp).format('MMM YYYY'))

      if (idx > -1) {
        recurring_customers += x?.recurring_customers
        one_time_customers += x?.one_time_customers
        cancelled_customers += x?.cancelled_customers
        net_gain += x?.net_gain
        if (customerFilterIdx === 0) series[idx] = (x?.recurring_customers)
        else if (customerFilterIdx === 1) series[idx] = (x?.one_time_customers)
        else if (customerFilterIdx === 2) series[idx] = (x?.cancelled_customers)
        else if (customerFilterIdx === 3) series[idx] = (x?.net_gain)
      }
    })

    return (
      <div className='franch-dash'>
        <div className="w-35 pr-30">
          {/* Customer Matrix */}
          {customerMatrix?.results?.length > 0 ? this.renderRevenueCard() : this.renderEmptyRevenueCard()}
        </div>
        <div className="bottom_grid w-65">
          {/* Top 3 Card Start */}
          {this.renderTopCards()}
          {/* Top 3 Card End */}

          <div className="table_with_chart" >
            <div className="card mr-30 mb-20">
              <div className="card-title flex ai-center" style={{padding: "10px 20px"}}>
                <h3 className="font-weight-bold pr-30">Customers</h3>
                <ul className="tabs mwhite d-block">
                  <li className={customerFilterIdx === 0 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 0})}><span>Recurring</span></li>
                  <li className={customerFilterIdx === 1 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 1})}><span>One-Time</span></li>
                  <li className={customerFilterIdx === 2 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 2})}><span>Cancellations</span></li>
                  <li className={customerFilterIdx === 3 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 3})}><span>Net Gain</span></li>
                  <li><div className={"only-icon-datepick"} style={{display: "flex", justifyContent: "flex-end"}}>
                    <DatePicker
                      disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                      onChange={this.onChangeCustomerMonth}
                      className="swhite summry_date_picker"
                      format="MMM YYYY"
                      picker="month"
                      allowClear={false}
                      value={customerMonth ? customerMonth : moment()}  />
                  </div>
                  </li>
                </ul>
              </div>
              <div className="card-body p-0">
                <div style={{ 'padding': '20px' }}>
                  <h2 className="mb-0">{customerFilterIdx === 0 ? recurring_customers : customerFilterIdx === 1 ? one_time_customers : customerFilterIdx === 2 ? cancelled_customers : customerFilterIdx === 3 ? net_gain : '0'}</h2>
                  <label className="mb-0">{customerFilterIdx === 0 ? 'Recurring Signups' : customerFilterIdx === 1 ? 'One-time' : customerFilterIdx === 2 ? 'Cancellation' : customerFilterIdx === 3 ? 'Net gain' : ''}</label>
                </div>

                {series?.length > 0 ?
                  <Chart
                    options={{...line_chart_options, xaxis: {
                      categories: categories,
                      labels: {
                        show: true,
                      },
                    }}}
                    series={[{data: series}]}
                    type="line"
                    height={'150'}
                  /> :
                  <Chart
                    options={{...line_chart_options}}
                    series={[{data: new Array(6).fill(0)}] }
                    type="line"
                    height={'150'}
                  />}

              </div>

              <ul className="chart_bottom_list">
                <li>
                  <h5>{recurring_customers ? recurring_customers : '0'}</h5>
                  <label>Recurring</label>
                </li>
                <li>
                  <h5>{one_time_customers ? one_time_customers : '0'}</h5>
                  <label>One-Time</label>
                </li>
                <li>
                  <h5>{cancelled_customers ? cancelled_customers : '0'}</h5>
                  <label>Cancellations</label>
                </li>
              </ul>
            </div>

          </div>

          {this.renderCallLoggedCard()}
          {/* Full Card Start*/}
          {this.renderCustomerSatisfaction()}
        </div>
      </div>
    )
  }


  //render product chart
  renderProductChart = () => {
    const { addon_options, productMonth, addonCollectionDetail, addon_series} = this.state;
    let total = 0;
    map(addonCollectionDetail?.results, x => total += x?.revenue)
    return (
      <div className="pie_chart_card inline-col-3 flex-1 pl-15">
        <div className="card">
          <div className="card-title flex align-items-center">
            <h3 className="font-weight-bold pr-30">Products</h3>
            <div style={{width: "130px"}}>
              <DatePicker
                disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                onChange={this.onChangeProductMonth}
                className="swhite summry_date_picker"
                format="MMM YYYY"
                picker="month"
                value={productMonth ? productMonth : moment()}  />
            </div>
          </div>
          <div className="card-body flex ai-center">
            {
              addon_series?.every(item => item === 0) ?
                <Chart
                  ref={(ref) => this.emptyProductChart = ref}
                  type="donut"
                  options={{...addon_options, colors: ['#ecebeb'], tooltip: {enabled: false}, states: {hover: 'none'} }}
                  series={[0.1]} /> :
                <Chart
                  type="donut"
                  options={{...addon_options, colors: pie_colors}}
                  series={addon_series} />
            }
            <ul className="chart_details_list">
              {map(addonCollectionDetail?.results, (item, index) => {
                if (item?.revenue) {
                  return (
                    <li key={item?.uuid} className={pie_colors_class[index]}>
                      <span>{item?.addon?.name || ''}</span>
                      <span>${item?.revenue ? formatToCurrency(item?.revenue) : '0.00'}</span>
                      <span>{item?.revenue ? parseFloat((item?.revenue * 100) / total).toFixed(2) : '0'}%</span>
                    </li>
                  )
                }
              } )}
            </ul>
          </div>
        </div>
      </div>
    )
  }

  //render service chart
  renderServiceChart = () => {
    const { service_type_options, serviceTypeCollection, serviceFilterIdx} = this.state;
    let total = 0, service_series = new Array(6).fill(0), service_legend = [];
    // series[0] = weekly, series[1] = EOW, series[2] = one time, series[3] = initial clean, series[4] = twice weekly, series[5] = other
    map(serviceTypeCollection?.results, x => {
      if (serviceFilterIdx === 0 && x?.service_type === 'residential') {
        switch (x?.frequency) {
        case 'weekly':
          service_series[0] = service_series[0] + x?.revenue
          break;
        case 'EOW':
          service_series[2] = service_series[1] + x?.revenue
          break;
        case 'once':
          service_series[2] = service_series[2] + x?.revenue
          break;
        case 'initial_clean':
          service_series[3] = service_series[3] + x?.revenue
          break;
        case 'twice_weekly':
          service_series[4] = service_series[4] + x?.revenue
          break;
        default:
          service_series[5] = service_series[5] + x?.revenue
        }
      } else if (serviceFilterIdx === 1 && x?.service_type === 'commercial') {
        switch (x?.frequency) {
        case 'weekly':
          service_series[0] = service_series[0] + x?.revenue
          break;
        case 'EOW':
          service_series[2] = service_series[1] + x?.revenue
          break;
        case 'once':
          service_series[2] = service_series[2] + x?.revenue
          break;
        case 'initial_clean':
          service_series[3] = service_series[3] + x?.revenue
          break;
        case 'twice_weekly':
          service_series[4] = service_series[4] + x?.revenue
          break;
        default:
          service_series[5] = service_series[5] + x?.revenue
        }
      }
    })

    service_legend = [{uuid: 0, name: 'Weekly', revenue: service_series[0]}, {uuid: 1, name: 'EOW', revenue: service_series[1]},
      {uuid: 2, name: 'One Time', revenue: service_series[2]}, {uuid: 3, name: 'Initial Clean', revenue: service_series[3]},
      {uuid: 4, name: 'Twice Weekly', revenue: service_series[4]}, {uuid: 5, name: 'Other', revenue: service_series[5]},
    ]
    
    map(serviceTypeCollection?.results, x => {
      if (serviceFilterIdx === 0 && x?.service_type === 'residential') total += x?.revenue
      else if (serviceFilterIdx === 1 && x?.service_type === 'commercial') total += x?.revenue
    })

    return (
      <div className="pie_chart_card inline-col-3 flex-1 pr-15">
        <div className="card">
          <div className=" flex card-title">
            <h3 className="font-weight-bold pr-30">Services</h3>
            <ul className="tabs mwhite d-block">
              <li className={serviceFilterIdx === 0 ? `active` : ''} onClick={() => this.setState({serviceFilterIdx: 0})}><span>Residential</span></li>
              <li className={serviceFilterIdx === 1 ? `active` : ''} onClick={() => this.setState({serviceFilterIdx: 1})}><span>Commercial</span></li>
            </ul>
          </div>
          <div className="card-body flex ai-center">
            {
              service_series?.every(item => item === 0) ?
                <Chart
                  ref={(ref) => this.emptyProductChart = ref}
                  type="donut"
                  options={{...service_type_options, colors: ['#ecebeb'], tooltip: {enabled: false}, states: {hover: 'none'} }}
                  series={[0.1]} /> :
                <Chart
                  type="donut"
                  options={{...service_type_options, colors: pie_colors}}
                  series={service_series} />
            }
            <ul className="chart_details_list">
              {map(service_legend, (item, index) => {
                if (item?.revenue) {
                  return (
                    <li key={item?.uuid}  className={pie_colors_class[index]}>
                      <span>{serviceFilterIdx === 0 ? 'Residential ' : 'Commercial '} {item?.name || ''}</span>
                      <span>${item?.revenue ? formatToCurrency(item?.revenue) : '0.00'}</span>
                      <span>{item?.revenue ? formatToCurrency(item?.revenue) : '0.00'}%</span>
                    </li>
                  )
                }
              } )}
            </ul>
          </div>
        </div>
      </div>
    )
  }

  //render tickets
  renderTickets = () => {
    const {messageData, ticket_filter, messageAssignedToMe, groupList} = this.state;
    return (
      <div className="card mb-20">
        <div className="card-title flex ai-center" style={{padding: "10px 20px"}}>
          <h3 className="font-weight-bold pr-30">Tickets</h3>
          <Select
            placeholder="Assigned To"
            showArrow
            virtual={false}
            style={{ width: '100%' }}
            value={ticket_filter}
            allowClear={true}
            className="from-control"
            onChange={(e) => this.onTicketFilterChange(e) }>
            <Option value={"me"} key={"me"}>{`Assigned to me`}</Option>
            {map(groupList?.results, (item) => {
              return (<Option value={item?.uuid} key={item?.uuid}>{item?.name}</Option>)
            })}
          </Select>
        </div>
        <div className={'card-body'}>
          <Table
            rowKey={record => record.uuid}
            dataSource={messageData?.results}
            pagination={false}
            columns={DataTable.FranchiseTicketList(this)}
            // onChange={this.onInvoiceChange}
            className="table invoice_table invoice_table_web"
          />
          <div className="greenbox" style={{border: "1px #407977 solid"}}>
            <h2 className={'success'}>{messageAssignedToMe?.results?.length}</h2>
            <div className={'flex'}>
              <b>Tickets assigned to me</b>
              <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/case-management', {table: 'assignedTickets'})}}><u className="success mt-10"><b>Go to Ticket Center</b></u></a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // render audit trail
  renderAuditTrail = () => {
    const {auditTrail} = this.state;
    return (
      <div className="card mb-20">
        <div className="card-title flex ai-center" style={{padding: "10px 20px"}}>
          <h5>Audit Trail</h5>
          {/*<Select*/}
          {/*  placeholder="Assigned To"*/}
          {/*  showArrow*/}
          {/*  virtual={false}*/}
          {/*  style={{ width: '100%' }}*/}
          {/*  value={audit_filter}*/}
          {/*  className="from-control"*/}
          {/*  onChange={(e) => {*/}
          {/*    this.onTextChange({target: {name: 'audit_filter', value: e}})*/}
          {/*    this.props.getAuditTrail({user__serviceorder__field_office__uuid: this.state?.data?.uuid, limit: 7, offset: 0, ordering: e})*/}
          {/*  } }>*/}
          {/*  <Option value="-created_at">Most Recent</Option>*/}
          {/*  <Option value="+created_at">Least Recent</Option>*/}
          {/*</Select>*/}
        </div>
        <div className={'card-body'}>
          <Table
            rowKey={record => record.uuid}
            dataSource={auditTrail?.results}
            pagination={false}
            columns={DataTable.AuditTrailList(this)}
            // onChange={this.onInvoiceChange}
            className="table invoice_table invoice_table_web"
          />
          {/*
          <div className={'mt-10'}  >
            <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports') }}><u className="success mt-10"><b>Go to Reporting</b></u></a>
          </div>
*/}
        </div>
      </div>
    )
  }

  render() {
    const {collectionDetail, loader} = this.state;
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).user
      : "";
    return (
      <div className="dashboard_wrapper">
        <div className="overview_wrapper franch-over">
          <div className="res-head mt-20 mb-20">
            <h3 className="mb-0">Welcome, {user?.first_name} {user?.last_name}! Dashboard features will be coming soon!</h3>
          </div>
          {loader && <Loader />}
          {/* <div className="px-25"> */}
            {/* <div className="aside-area pt-0"> */}
              {/* <div className="main p-0 bg-transparent"> */}
                {/* Full Card End*/}
                {/* {this.renderCustomerCard()} */}
                {/* Full Card Start*/}
                {/* {this.renderFullCard()}
                <div className="bottom_grid flex flex-start mb-20 mr-30">
                  <Table
                    rowKey={record => record.uuid}
                    dataSource={collectionDetail?.results}
                    pagination={false}
                    columns={DataTable.FranchiseCollection(this)}
                    className="table"
                  />
                </div> */}
              {/* </div> */}
              {/* <aside className="pr-0">
                {this.renderTickets()}
                {this.renderAuditTrail()}
              </aside> */}
            {/* </div> */}

            {/* <div className={'flex'}>
              {this.renderServiceChart()}
              {this.renderProductChart()}
            </div> */}
          {/* </div> */}
        </div>
      </div>
    );
  }
}

export default FranchiseDashboard;